import getKnownFilters from './getKnownFilters';
import {
  TASK_INSTANCES_KNOWN_FILTERS_TO_FILEDS_MAP,
  TASK_INSTANCES_STATUS_FILTER_NAME,
  TASK_INSTANCES_STATE_FILTER_NAME,
  TASK_INSTANCE_UNASSIGNED_STATE,
  TASK_INSTANCE_ASSIGNED_STATE,
  TASK_INSTANCE_AVAILABLE_STATE,
} from '../../constants';

export default function filterTaskInstances(instances, filters, query) {
  const knownFilters = getKnownFilters(filters);

  return instances.filter((taskInstance) =>
    Object.keys(knownFilters).every((filterName) => {
      if (!doesInstanceMatchSearchQuery(taskInstance, query)) {
        return false;
      }

      if (!knownFilters[filterName]?.length) {
        return true;
      }
      const fieldName = TASK_INSTANCES_KNOWN_FILTERS_TO_FILEDS_MAP[filterName];

      if (!fieldName) {
        if (filterName === TASK_INSTANCES_STATUS_FILTER_NAME) {
          return doesInstanceMatchStatusFilter(taskInstance, knownFilters[filterName]);
        }
        if (filterName === TASK_INSTANCES_STATE_FILTER_NAME) {
          return doesInstanceMatchStateFilter(taskInstance, knownFilters[filterName]);
        }
        return false;
      }

      return taskInstance[fieldName] && knownFilters[filterName].includes(taskInstance[fieldName]);
    })
  );
}

export function doesInstanceMatchSearchQuery(instance, query) {
  if (!query) {
    return true;
  }

  return instance.title.toLowerCase().includes(query.toLowerCase().trim());
}

export function doesInstanceMatchStatusFilter(taskInstance, statusFilter) {
  if (!statusFilter?.length) {
    return true;
  }

  return statusFilter.some((status) => taskInstance.status === status);
}

export function doesInstanceMatchStateFilter(taskInstance, stateFilter) {
  if (!stateFilter?.length) {
    return true;
  }

  return stateFilter.some((state) => {
    if (state === TASK_INSTANCE_UNASSIGNED_STATE) {
      return taskInstance.assigneeId === null && taskInstance.available === false;
    }

    if (state === TASK_INSTANCE_ASSIGNED_STATE) {
      return taskInstance.assigneeId;
    }

    if (state === TASK_INSTANCE_AVAILABLE_STATE) {
      return taskInstance.assigneeId === null && taskInstance.available === true;
    }

    return false;
  });
}
